import { render, staticRenderFns } from "./TekshiruvShablonli.vue?vue&type=template&id=34a14e2c"
import script from "./TekshiruvShablonli.vue?vue&type=script&lang=js"
export * from "./TekshiruvShablonli.vue?vue&type=script&lang=js"
import style0 from "./TekshiruvShablonli.vue?vue&type=style&index=0&id=34a14e2c&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports